import React, { useState } from "react";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import "./Sidebar.css";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PsychologyAltOutlinedIcon from "@mui/icons-material/PsychologyAltOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import NumbersIcon from "@mui/icons-material/Numbers";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import ArticleIcon from "@mui/icons-material/Article";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const [isCollapsedSidebar, setisCollapsedSidebar] = useState(false);

  const toggleSidebarCollapseHandler = () => {
    setisCollapsedSidebar((prev) => !prev);
    console.log(isCollapsedSidebar);
  };

  return (
    <>
      <aside data-collapse={isCollapsedSidebar}>
        <div id="side_nav">
          <div id="side_header" className="row">
            <span className="sidebar_nav_txt">
              <div className="logo">
                <span id="org">Shrayati</span>
              </div>
            </span>
            <button
              className="toggle gray toggle_btn"
              onClick={toggleSidebarCollapseHandler}
            >
              <MenuOpenIcon />
            </button>
          </div>
          <div id="nav_links">
            <div id="link">
              <Link to="https://darkgray-donkey-340304.hostingersite.com/" target="_blank">
                <span>
                  <DashboardOutlinedIcon />
                </span>
                <b className="sidebar_nav_txt">WordPress </b>
              </Link>
              <Link to="/">
                <span>
                  <HomeRoundedIcon />
                </span>
                <b className="sidebar_nav_txt">Landing Page</b>
              </Link>
              <small className="sidebar_nav_txt">Customize</small>
              <Link to="/dashboard/editMainSlider">
                <span>
                  <FavoriteBorderOutlinedIcon />
                </span>
                <b className="sidebar_nav_txt">Main Slider</b>
              </Link>
              <small className="sidebar_nav_txt">Edit Details</small>
              <Link to="/dashboard/editAbout">
                <span>
                  <LanguageOutlinedIcon />
                </span>
                <b className="sidebar_nav_txt">About </b>
              </Link>
              <Link to="/dashboard/editVisionMission">
                <span>
                  <PsychologyAltOutlinedIcon />
                </span>
                <b className="sidebar_nav_txt">Vision & Mission</b>
              </Link>
              <Link to="/dashboard/editStory">
                <span>
                  <MenuBookOutlinedIcon />
                </span>
                <b className="sidebar_nav_txt">Story</b>
              </Link>
              <Link to="/dashboard/editCore">
                <span>
                  <Diversity2Icon />
                </span>
                <b className="sidebar_nav_txt">Core Values</b>
              </Link>
              <Link to="/dashboard/editNumbers">
                <span>
                  <NumbersIcon />
                </span>
                <b className="sidebar_nav_txt">Numbers</b>
              </Link>
              <Link to="/dashboard/editInvestorD">
                <span>
                  <LocalAtmIcon />
                </span>
                <b className="sidebar_nav_txt">Investor's Overview</b>
              </Link>
              <Link to="/dashboard/editPress">
                <span>
                  <ArticleIcon />
                </span>
                <b className="sidebar_nav_txt">Press Releases</b>
              </Link>
              <Link to="/dashboard/editTestimonials">
                <span>
                  <FeedbackOutlinedIcon />
                </span>
                <b className="sidebar_nav_txt">Testimonials</b>
              </Link>
              <Link to="/dashboard/login">
                <span>
                  <LogoutOutlinedIcon />
                </span>
                <b className="sidebar_nav_txt">Logout</b>
              </Link>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
